<template>
  <div class="ksm-flex-1 ksm-flex-column">
    <div class="ksm-texte__colorbar" :class="'ksm-texte__colorbar--'+modus.id"></div>
    <keep-alive>
      <component class="ksm-flex-1" :is="modus.id" :viewKey="viewKey">
        <!--toolbar start-->
        <div slot="modusindex-toolbar" class="ksm-texte__modus_toolbar">
          <!--select group 1-->
          <div v-if="modus.id!=='kompositionsmodus'" class="ksm-texte__merz-select">
            <div>
              <select @change="changeMerz" v-model="selectedUrlparmas.merzId">
                <option
                  v-for="(merz,i) in merzListe"
                  :value="merz.id"
                  :key="i"
                >{{merz.name.trim().replace(/^Merz/,'Merz ')}}</option>
              </select>
            </div>
            <div style="margin-left:-2px">
              <select
                @change="changeSeite"
                v-model="selectedUrlparmas.seiteIdx"
                style="width:auto; max-width:20em;"
              >
                <option v-for="(s,j) in seiten" :value="j" :key="j">{{s.name}}</option>
              </select>
            </div>
          </div>
          <div v-else class="ksm-texte__merz-select">
            <div style="margin-left:-2px; visibility:hidden">
              <select>
                <option>Meine Komposition 1</option>
              </select>
            </div>
          </div>

          <!--modus navigation-->
          <div class="ksm-texte__modus-navigation">
            <div
              v-for="(it,i) in modusData.modusItems"
              class="ksm-texte__modus-navItem"
              :class="'ksm-modus__navi--'+it.id+(it.id==modus.id?' active':'')"
              @click="changeModus(it)"
              v-html="$_getSvg(it.img)"
              :title="it.label"
              :key="'nav'+i"
            ></div>
          </div>
          <div v-if="modus.id=='untersuchungsmodus'" class="ksm-transparent-slider">
            <div>
              <input
                id="slider1"
                type="range"
                @input="changeTransparent"
                min="0"
                max="100%"
                step="1"
                :value="transparenzValue"
                class="ksm-slider"
                style="width:100%"
              >
            </div>
            <div class="__text">
              <div>0%</div>
              <div class="ksm-flex-1 ksm-flex-xy-center">Transparenz</div>
              <div>100%</div>
            </div>
          </div>
          <!--select group 2-->
          <div v-if="modus.id=='vergleichsmodus'" class="ksm-texte__merz-select">
            <div>
              <select @change="b_changeMerz" v-model="selectedUrlparmas.b_merzId" style>
                <option
                  v-for="(merz,i) in merzListe"
                  :value="merz.id"
                  :key="i"
                >{{merz.name.trim().replace('Merz','Merz ')}}</option>
              </select>
            </div>
            <div style="margin-left:-2px">
              <select
                @change="b_changeSeite"
                v-model="selectedUrlparmas.b_seiteIdx"
                style="width:auto; max-width:20em"
              >
                <option v-for="(s,j) in b_seiten" :value="j" :key="j">{{s.name}}</option>
              </select>
            </div>
          </div>

          <div v-if="modus.id=='kompositionsmodus'" class="ksm-texte__merz-select">
            <div>
              <select @change="changeMerz" v-model="selectedUrlparmas.merzId">
                <option
                  v-for="(merz,i) in merzListe"
                  :value="merz.id"
                  :key="i"
                >{{'Merz '+merz.name.replace('Merz','').trim()}}</option>
              </select>
            </div>
            <div style="margin-left:-2px">
              <select
                @change="changeSeite"
                v-model="selectedUrlparmas.seiteIdx"
                style="width:auto; max-width:20em"
              >
                <option v-for="(s,j) in seiten" :value="j" :key="j">{{s.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <!--toolbar end-->
      </component>
    </keep-alive>
  </div>
</template>

<script>
import Ansichtsmodus from "./Ansicht.vue";
import Vergleichsmodus from "./Vergleich.vue";
import Kompositionsmodus from "./Komposition.vue";
import Untersuchungsmodus from "./Untersuchung.vue";
import MixinsModus from "comps/mixins/Modus.vue";

export default {
  name: "modusindexsite",
  props: ["viewKey"],
  mixins: [MixinsModus],
  components: {
    ansichtsmodus: Ansichtsmodus,
    vergleichsmodus: Vergleichsmodus,
    kompositionsmodus: Kompositionsmodus,
    untersuchungsmodus: Untersuchungsmodus
  },
  data() {
    return {
      selectedUrlparmas: {
        merzId: null,
        seiteIdx: null,
        b_merzId: null,
        b_seiteIdx: null
      }
    };
  },
  watch: {
    modusUrlparams: {
      deep: true,
      handler: function(val, oldVal) {
        this.updateUrlparmams(val);
      }
    }
  },

  mounted: function() {
    if (this.modusUrlparams) {
      this.updateUrlparmams(this.modusUrlparams);
    }
  },

  methods: {
    updateUrlparmams(val) {
      this.$_extend(this.selectedUrlparmas, val);
    },
    changeModus(modus) {
      this.$_modusChangeEvent("modus/changeModus", {
        modus: modus
      });
    },
    b_changeMerz(e) {
      this.$_modusChangeEvent("modus/b_changeMerz", {
        modus: this.modus,
        merzId: e.target.value
      });
    },

    changeMerz(e) {
      this.$_modusChangeEvent("modus/changeModusMerz", {
        modus: this.modus,
        merzId: e.target.value
      });
    },

    b_changeSeite(e) {
      this.$_modusChangeEvent("modus/b_changeSeite", {
        modus: this.modus,
        seiteIdx: e.target.value
      });
    },

    changeSeite(e) {
      this.$_modusChangeEvent("modus/changeModusSeite", {
        modus: this.modus,
        seiteIdx: e.target.value
      });
    },

    changeTransparent(e) {
      this.$_modusChangeEvent("modus/changeTransparenz", {
        modus: this.modus,
        val: e.target.value
      });
    }
  },
  computed: {
    // b_seiten() {
    //   return this.$store.getters["modus/b_seiten"](this.modus);
    // },
    sourceData() {
      return this.$store.state[this.viewKey];
    },

    modusData() {
      return this.sourceData.modusData;
    },
    merzListe() {
      return this.sourceData.merzListe;
    },
    modus() {
      return this.modusData.active_modus;
    },
    // seiten() {
    //   return this.$store.getters["modus/getModusSeiten"](this.modus);
    // },

    modusUrlparams() {
      return this.$store.getters["modus/getModusUrlparams"](this.modus);
    },

    transparenzValue() {
      const untersuchungsmodus = this.modusData.modusItems.find(
        m => m.id === "untersuchungsmodus"
      );
      return untersuchungsmodus.option.transparenz;
    }
  }
};
</script>

<style lang='scss'>
.ksm-texte__colorbar {
  @extend .ksm-flex-00auto;
  height: 8px;
}
.ksm-texte__colorbar--ansichtsmodus {
  background-color: $ansicht-color;
}
.ksm-texte__colorbar--untersuchungsmodus {
  background-color: $untersuchung-color;
}
.ksm-texte__colorbar--vergleichsmodus {
  background-color: $vergleich-color;
}
.ksm-texte__colorbar--kompositionsmodus {
  background-color: $komposition-color;
}

// .ksm-texte__merz-select {
//   @extend .ksm-flex;
//   @extend .ksm-flex-00auto;
//   @extend .ksm-control-font;
//   select {
//     height: 100%;
//     padding: 0px 2.5em 0px 5px;
//     appearance: none;
//     -webkit-appearance: none;
//     -moz-appearance: none;
//     -ms-appearance: none;
//     border: 2px solid $darkGrey;
//     background: url('data:image/svg+xml;utf8,<svg id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect width="512" height="512" fill="rgb(192,202,209)"></rect><path transform="scale(0.8) translate(50,50)" fill="rgb(102,102,102)" d="M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6 c1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z"></path></svg>');
//     background-repeat: no-repeat;
//     background-position: right 0px;
//     font-size: 10pt;
//     min-width: 50px;
//     cursor: pointer;
//   }
// }

.ksm-texte__modus-navigation {
  @extend .ksm-flex-1;
  @extend .ksm-flex-xy-center;
  height: 100%;
  position: relative;
  padding: 0px 20px;
  .ksm-texte__modus-navItem {
    margin: 0px 3px;
    height: 100%;
    &:hover {
      @extend .active;
    }
  }
}

.ksm-texte__show-transcript {
  height: 100%;
  width: 46px;
  margin-left: 5px;
}

.ksm-transparent-slider {
  min-width: 200px;
  flex: 0 0 20%;
  .__text {
    @extend .ksm-flex;
    opacity: 0.7;
    font-size: 0.8em;
  }
}
</style>


// WEBPACK FOOTER //
// ModusIndex.vue?6cf2fa22